var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82867 12.0002H2V9.17155L9.62333 1.54822C9.74835 1.42324 9.91789 1.35303 10.0947 1.35303C10.2714 1.35303 10.441 1.42324 10.566 1.54822L12.452 3.43422C12.577 3.55924 12.6472 3.72878 12.6472 3.90555C12.6472 4.08233 12.577 4.25187 12.452 4.37689L4.82867 12.0002ZM2 13.3336H14V14.6669H2V13.3336Z",
    fill: "#8F91AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4307c1775b2d2c4614d4fc60c752a27f.svg";
export { ForwardRef as ReactComponent };